module.exports = __webpack_public_path__ + "img/autosense-account-flows.ef21a179.png";